export const validLensModelColumns = [
    {
        Header: "Model Name",
        accessor: "modelName",
        canFilter: true,
        filterPlaceholder: "Filter by model",
        width: 200,
    },
    {
        Header: "Manufacturer",
        accessor: "manufacturer.name",
        canFilter: true,
        filterPlaceholder: "Filter by manufacturer",
        width: 180,
    },
    {
        Header: "Brand",
        accessor: "manufacturerBrand.brandName",
        width: 150,
    },
    {
        Header: "Lens Type",
        accessor: "lensType",
        Cell: ({ value }) => {
            const typeLabels = {
                'single_vision': 'Single Vision',
                'bifocal': 'Bifocal',
                'trifocal': 'Trifocal',
                'progressive': 'Progressive',
                'aphakic': 'Aphakic',
                'vocational': 'Vocational',
            };
            return value ? typeLabels[value] || value : '—';
        },
        canFilter: true,
        filterPlaceholder: "Filter by type",
        width: 140,
    },
    {
        Header: "Base Cost",
        accessor: "baseCost",
        Cell: ({ value }) => value ? `$${parseFloat(value).toFixed(2)}` : '-',
        width: 100,
    },
    {
        Header: "Base Retail",
        accessor: "baseRetailPrice",
        Cell: ({ value }) => value ? `$${parseFloat(value).toFixed(2)}` : '-',
        width: 120,
    },
    {
        Header: "Status",
        accessor: "status",
        canFilter: true,
        filterPlaceholder: "Filter by status",
        width: 100,
    },
];
